import React from 'react';
import '../../board/toolbar/BoardClickUpFilterChip.css';

/**
 * Chip de filtro — mesmo padrão visual da toolbar do Board (ClickUp).
 */
export function EcClickUpFilterChip({
  label,
  value,
  icon: Icon,
  hasSelection = false,
  isOpen = false,
  disabled = false,
  ariaLabel,
  onClick,
  badge = null,
  anchorRef,
  className = '',
  showValue = true,
  tooltip = null,
  tooltipMultiline = false,
}) {
  const displayValue = value != null && String(value).length > 0;

  return (
    <div className="board-clickup-filter-chip-anchor" ref={anchorRef}>
      <button
        type="button"
        className={[
          'board-clickup-filter-chip',
          hasSelection ? 'has-selection' : '',
          isOpen ? 'is-open' : '',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        disabled={disabled}
        aria-label={ariaLabel || `Filtrar por ${label}`}
        aria-expanded={isOpen}
        onClick={onClick}
      >
        {Icon ? (
          <span className="board-clickup-filter-chip-icon" aria-hidden="true">
            <Icon size={13} stroke={1.5} />
          </span>
        ) : null}
        <span className="board-clickup-filter-chip-text">
          <span className="board-clickup-filter-chip-label">{label}</span>
          {showValue && displayValue ? (
            <>
              <span className="board-clickup-filter-chip-separator">:</span>
              <span className="board-clickup-filter-chip-value">{value}</span>
            </>
          ) : null}
        </span>
        {badge}
      </button>
      {tooltip ? (
        <span
          className={[
            'board-clickup-tooltip',
            'board-clickup-tooltip--bottom',
            tooltipMultiline ? 'hub-feedback-tooltip--wrap' : '',
          ]
            .filter(Boolean)
            .join(' ')}
          role="tooltip"
        >
          {tooltip}
        </span>
      ) : null}
    </div>
  );
}
